export const open_in_new_tab = (url: string) => globalThis.open(url, '_blank');

export const open_in_this_tab = (url: string) =>
    // @ts-ignore
    globalThis.location = url;
